// Hero/cover imagery — unique AI-generated covers per secondary page.
// Other inline imagery still uses Unsplash.
import coverAbout from "@/assets/cover-about.webp";
import coverServices from "@/assets/cover-services.webp";
import coverAccounting from "@/assets/cover-accounting.jpg";
import coverAuditing from "@/assets/cover-auditing.webp";
import coverTax from "@/assets/cover-tax.webp";
import coverResources from "@/assets/cover-resources.webp";
import coverNewsletter from "@/assets/cover-newsletter.webp";
import coverBlog from "@/assets/cover-blog.webp";
import coverFaq from "@/assets/cover-faq.webp";
import coverContact from "@/assets/cover-contact.webp";
import coverTerms from "@/assets/cover-terms.webp";
import coverCities from "@/assets/cover-cities.webp";
import serviceAccounting from "@/assets/service-accounting.webp";
import serviceAuditing from "@/assets/service-auditing.webp";
import serviceTaxation from "@/assets/service-taxation.webp";
import serviceTaxPrep from "@/assets/service-tax-preparation.jpg";
import servicePayroll from "@/assets/service-payroll.jpg";

const u = (id: string, w = 1600) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

export const img = {
  // Page hero / cover images (unique per route)
  heroHome: u("photo-1554224155-6726b3ff858f"),
  heroAbout: coverAbout,
  heroServices: coverServices,
  heroAccounting: coverAccounting,
  heroAuditing: coverAuditing,
  heroTax: coverTax,
  heroResources: coverResources,
  heroBlog: coverBlog,
  heroFaq: coverFaq,
  heroContact: coverContact,
  heroTerms: coverTerms,
  heroCities: coverCities,

  // In-page imagery
  about: u("photo-1573497491208-6b1acb260507"),
  accounting: serviceAccounting,
  auditing: serviceAuditing,
  tax: serviceTaxation,
  taxPrep: serviceTaxPrep,
  payroll: servicePayroll,
  consultation: u("photo-1573497019940-1c28c88b4f3e"),
  office: u("photo-1497366754035-f200968a6e72"),
  planning: u("photo-1542744173-8e7e53415bb0"),
};
